import script from "./RightMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RightMenu.vue?vue&type=script&setup=true&lang=js"

import "./RightMenu.vue?vue&type=style&index=0&id=a30aba16&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a30aba16"]])

export default __exports__